const initialState = {
    filters: {}
};

export default function commissions(state = initialState, action = {}) {
    switch (action.type) {
        case 'UPDATE_ORDERS_FILTERS_FORM':
            return {
                ...state,
                filters: action.payload
            }
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/components/Pages/Commissions/reducer.js